import React from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import {ItemModelV2_CalculatedValues} from "../../../../../../../model2/item2/calculated/@type"
import FieldProto from "../../../../../../proto/field-proto"
import {areJSONObjectPropsEqual} from "../../../../../../../gd/utils/compare"
import StatusSummaryBar from "../../../../../../generic/status/render/table/calculated/summary"
import TasksView_Column from "../../../../../../../model2/column/column"

type Props = {
    className?      : string
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto
    status          : any

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldProjectStatus_TableCellCalculated_NotHovered"
const debug = false

export default function FieldProjectStatus_TableCellCalculated_NotHovered(props: Props) {

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const showSummaryView   = (/*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed) &&
        calculatedValues?.total.summary &&
        !areJSONObjectPropsEqual(calculatedValues.total.summary,calculatedValues.own.summary)

    debug && console.log(debug, "renderNotHovered", props.listItem.debugName, showSummaryView, calculatedValues)

    let notHoveredContent
    if (showSummaryView) {
        notHoveredContent = <StatusSummaryBar data={calculatedValues.total.summary!}/>
    } else {
        switch (props.listItem.project.systemType) {
            case gd.const.project.type.TAG          :
            case gd.const.project.type.WORKFOLDER   :
                // Do nothing

            default:
                if (props.status) {
                    notHoveredContent = (
                        <div className={Classes('ui5-status-list status-c{0}'.f(props.status.color), props.className)}>
                            <div className="max-w-100-percent txt-truncate">{props.status.name}</div>
                        </div>
                    )
                }
        }
    }

    const classes = Classes("cell-flex border-1px-transparent", {
        // 'is-expanded-calculated': props.listItem.isGroup && !props.listItem.view.isCollapsed
    })

    return (
        <div className      = {classes}
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {notHoveredContent}
        </div>
    )
}
